import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import lightGallery from 'lightgallery';

export function LightboxFilterGallery() {
    const galleries = document.querySelectorAll('.wp-block-ssm-filtered-gallery');

    galleries.forEach((gallery) => {
      const images = gallery.querySelectorAll('.wp-block-ssm-filterable-image');
      let isLightbox = false;

      images.forEach((image) => {
        if(image.querySelector('a')) {
          isLightbox = true;
        }
      });

      if(isLightbox) {
        lightGallery(gallery, {
          licenseKey: '4B0B052C-5BCB4CCF-99EF0E30-D0B78394',
          selector: '.wp-block-ssm-filterable-image a',
          download: false,
        });
      }
    });
  }

export function FilterGallery() {
    const grid = document.querySelector('.gallery-filterable');

    if(!grid) return;

    const iso = new Isotope(grid, {
        itemSelector: '.wp-block-ssm-filterable-image',
        layoutMode: 'fitRows',
        fitRows: {
            gutter: 32
        }
    });

    imagesLoaded(grid).on('progress', function() {
        iso.layout();
    });

    document.querySelectorAll('.gallery-filter button').forEach(button => {
        button.addEventListener( 'click', (e) => {
            if(button.classList.contains('is-active')) return;
            document.querySelector('.gallery-filter button.is-active').classList.remove('is-active');
            button.classList.add('is-active');
            iso.arrange({ filter: button.getAttribute('data-filter') });
        });
    });
}
